/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * AddExportModal.tsx
 */

import React from "react";
import Modal, {ModalProps, ModalState} from "../layout/Modal";
import Button from "./button/Button";
import Colors from "../../model/enumerations/Colors";
import NavigationService from "../../service/NavigationService";
import AuthenticationService from "../../service/AuthenticationService";

interface Props extends ModalProps {
}

interface State extends ModalState {
}

export default class MenuDropdown extends Modal<Props, State> {
    public state: State;
    private readonly _authService : AuthenticationService;
    private readonly _navigationService : NavigationService;

    constructor(props: Props, state: State) {
        super(props, state);

        this._authService = this._serviceRepository.resolve(AuthenticationService.id) as AuthenticationService;
        this._navigationService = this._serviceRepository.resolve(NavigationService.id) as NavigationService;

        this.state = {
            loading: false
        };
    }

    /**
     * onSave
     */
    public onSave = undefined;

    private _logout = () => {
        this._authService.logout(true);
        this._navigationService.load("/");
    }

    /**
     * renderBody
     */
    public renderBody(): JSX.Element {
        return <div>
            <Button outline={true} fullwidth={true} color={Colors.red} labelAccessor={t => t.headerLogout} onClick={this._logout} />
        </div>
    }
}